import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

Vue.use(VueFormWizard)


Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        background: '#f0f2f2',
        primary: '#20c09e',
        secondary: '#415b64',
        accent: '#20c09e',
        error: '#cb0f0a',
        info: '#67afca',
        success: '#46c09d',
        warning: '#ffff00'
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js